import React from 'react';
import clsx from 'clsx';

import Button from '@common/Button';

const FlexButtons = ({ data }) => {
  const {
    imagePosition,
    buttons,
    images,
    links,
  } = data;
  return (
    <div className={clsx('d-flex flex-column flex-sm-row justify-content-center', {
      'mb-3': imagePosition === 'Center',
      'justify-content-lg-start ms-lg-n1': (images || links) && imagePosition !== 'Center',
      })}>
      {buttons.map(button => (
        <Button
          key={button.id}
          to={button.link}
          variant={button.variant}
          size={button.size}
          addClass={clsx('scale-1 mb-2 m-sm-1', button.class)}
          copy={button.copy}
          icon={button.icon}
          iconSize={button.iconSize}
          iconPosition={button.iconPosition}
          modal={button.modal}
        />
      ))}
    </div>
  )
}

export default FlexButtons
